import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography,IconButton } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar"
import PropTypes from 'prop-types';
import CloseIcon from "@material-ui/icons/Close";
import information from '../assets/icons/white-information-circle.png';
import CloseButton from "../CustomizedUIs/CloseButton";
const useStyles = makeStyles(theme => ({
  close: {
    padding: theme.spacing(0.5)
  },
  container: {
    marginTop: '5.5em',
  },
  containerInherit: {
    position: 'inherit'
  },
  root:{
    backgroundColor:"#2b3648",
  }
}));


export default function SnackbarCustom({ message, open, handleClose, inherit }) {
  const classes = useStyles();

  return (
    <div>
      <Snackbar
        className={inherit ? classes.containerInherit : classes.container}
        ContentProps={{
          classes: {root:classes.root}
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={
          <Box display='flex'>
             <img src={information} width="10%" style={{ marginRight: '10px' }} />
            <Typography align='center' variant="body2">
              {message}
            </Typography>
          </Box>
        }
        action={
            <React.Fragment>
              <Box display="flex">
                <Box bgcolor="#ffffff" width={2} />
                <CloseButton onClick={handleClose}/>
              </Box>
            </React.Fragment>
          }
      />
    </div>
  );
}

SnackbarCustom.propTypes = {
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleUndo: PropTypes.func,
  inherit: PropTypes.bool
};
